<div class="additional-info">
  <h3>Additional information</h3>
  <ul>
    <li *ngFor="let additionalInfo of additionalInformation">
      <span class="additional-info__title" *ngIf="additionalInfo?.title">{{ additionalInfo?.title }}: </span><span>{{ additionalInfo?.note }}</span>
    </li>
  </ul>
</div>
